import { render, staticRenderFns } from "./ppt.vue?vue&type=template&id=06adfe70&"
import script from "./ppt.vue?vue&type=script&lang=js&"
export * from "./ppt.vue?vue&type=script&lang=js&"
import style0 from "./ppt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports